/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 4;
      this.products = [];

      this.excludedHandles = (this.dataset.excludedHandles || '')
        .split(',')
        .map((handle) => handle.trim())
        .filter(Boolean);

      window.recentlyViewedIds = [];

      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds) {
          try {
            window.recentlyViewedIds = JSON.parse(recentIds) || [];
          } catch (e) {
            window.recentlyViewedIds = [];
          }
        }
      }
    }

    connectedCallback() {
      if (!this.container || !window.recentlyViewedIds.length) {
        this.style.display = 'none';
        return;
      }

      this.buildUrl();
    }

    buildUrl() {
      let i = 0;

      window.recentlyViewedIds.forEach((val) => {
        // huidige product overslaan
        if (val === this.currentId) {
          return;
        }

        // uitgesloten producten overslaan
        if (this.excludedHandles.includes(val)) {
          return;
        }

        // max aantal respecteren
        if (i >= this.max) {
          return;
        }

        this.products.push('handle:' + val);
        i++;
      });

      if (!this.products.length) {
        this.style.display = 'none';
        return;
      }

      this.url += encodeURIComponent(this.products.join(' OR '));
      this.fetchProducts();
    }

    fetchProducts() {
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
          } else {
            this.style.display = 'none';
          }
        })
        .catch((e) => {
          console.error(e);
          this.style.display = 'none';
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}